import React from "react";

import {
  useDataGrid,
  DataGrid,
  GridColumns,
  EditButton,
  DeleteButton,
  List,
  Stack,
  esES,
} from "@pankod/refine-mui";
import { IWax } from "interfaces";

export const WaxList: React.FC = () => {
  const { dataGridProps } = useDataGrid<IWax>({
    metaData: {
      populate: ["employee"],
    },
  });

  const columns = React.useMemo<GridColumns<IWax>>(
    () => [
      {
        field: "employee",
        headerName: "Empleado",
        flex: 1,
        valueGetter: (params) => params?.row?.employee?.name || "",
      },
      { field: "type", headerName: "Tipo", flex: 1 },
      { field: "parts", headerName: "Total Piezas", flex: 1 },
      {
        headerName: "Acciones",
        headerAlign: "center",
        field: "actions",
        minWidth: 180,
        align: "center",
        flex: 1,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton size="small" hideText recordItemId={params.row.id} />
              <DeleteButton
                size="small"
                hideText
                recordItemId={params.row.id}
              />
            </Stack>
          );
        },
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        autoHeight
        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
      />
    </List>
  );
};
